import "bootstrap/dist/css/bootstrap.min.css";
import { ConnectedRouter } from "connected-react-router";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { OidcProvider } from "redux-oidc";
import { ThemeProvider } from "styled-components";
import App from "./App";
import "./index.css";
import { history, store } from "./redux/store";
import userManager from "./redux/userManager";
import * as serviceWorker from "./serviceWorker";
import { DefaultStyle } from "./styles";
import { theme } from "./styles/theme";

// Force the "www" subdomain otherwise MSAL will fail as the redirect URL is configured as www...
if (window.location.href.startsWith("https://technolibrary")) {
    const wwwUrl = window.location.href.replace("https://technolibrary", "https://www.technolibrary");
    window.location.href = wwwUrl;
} else {
  const root = createRoot(document.getElementById("root")!);
  root.render(
    <ThemeProvider theme={theme}>
      <DefaultStyle />
      <Provider store={store}>
        <OidcProvider userManager={userManager} store={store}>
          <ConnectedRouter history={history}>
            <App />
          </ConnectedRouter>
        </OidcProvider>
      </Provider>
    </ThemeProvider>
  )
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
